import Vue from 'vue'
import axios from '../../../axios/index.js'
import store from '../../../../store/store.js'
import router from '@/router'
import {VoriantGuard} from '@/components/voriant-guard/VoriantGuard'

// Token Refresh
let isAlreadyFetchingAccessToken = false
let startedWSSConnection = false
let subscribers = []

function addSubscriber (callback) {
  subscribers.push(callback)
}

async function initGuard (accessToken) {
  startedWSSConnection = false
  Vue.prototype.$VoriantGuard = new VoriantGuard({
    url: 'wss://sims-guard.intellectualpoint.com',
    //   url: 'ws://localhost:7171',
    token: accessToken,
    autoConnect: false,
    autoReconnect: true
  })
}

function loadGuard (accessToken) {
  initGuard(accessToken).then(() => {
    if (startedWSSConnection === false) {
      startedWSSConnection = true
      Vue.prototype.$VoriantGuard.connect()
    }
  })
}

function onAccessTokenFetched (data) {
  localStorage.setItem('accessToken', data.accessToken)
  localStorage.setItem('refreshToken', data.refreshToken)
  localStorage.setItem('userInfo', JSON.stringify(data.user))
  Vue.prototype.$http.defaults.headers.common['Authorization'] = `Bearer ${data.accessToken}`
  axios.defaults.headers.common['Authorization'] = `Bearer ${data.accessToken}`
  subscribers = subscribers.filter(callback => callback(data.accessToken))
  loadGuard(localStorage['accessToken'])
}


export default {
  async init () {

    if (localStorage['accessToken'] !== undefined) {
      axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage['accessToken']}`
      loadGuard(localStorage['accessToken'])
    }

    axios.interceptors.response.use((response) => {
      return response
    }, (error) => {

      // const { config, response: { status } } = error
      const {config, response} = error
      const originalRequest = config

      if (response && response.status === 401) {
        if (isAlreadyFetchingAccessToken === false) {
          isAlreadyFetchingAccessToken = true
          store.dispatch('auth/fetchAccessToken')
            .then((response) => {
              onAccessTokenFetched(response.data.data)
            })
            .catch(() => {
              isAlreadyFetchingAccessToken = false
              return this.logout()
            })
        }

        return new Promise((resolve) => {
          addSubscriber(access_token => {
            originalRequest.headers.Authorization = `Bearer ${access_token}`
            resolve(axios(originalRequest))
          })
        })
      } else if (response && response.status === 429) {
        //const time = response.data.data.resets
        //Notification
      }
      return Promise.reject(error)
    })
  },

  refreshUserObject () {
    return axios.get('users/@me')
  },

  refreshCourseObject () {
    return axios.get('users/@me/active-course')
  },
  login (username, password, captcha) {
    return axios.post('auth/login', {username, password, captcha})
  },
  logout () {
    localStorage.removeItem('refreshToken')
    localStorage.removeItem('accessToken')
    router.push('/login')
  },
  registerUser (first_name, last_name, username, password, recaptcha) {
    return axios.post('auth/register', {
      first_name, last_name, username, password, recaptcha
    })
  },
  refreshToken () {
    return axios.post('auth/refresh', {
      refresh_token: localStorage.getItem('refreshToken')
    }).catch(() => {
      this.logout()
    })
  }
}
